<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 card-box">
        <!-- Personal Info -->
        <h4 class="col-12 mb-2 text-uppercase bg-light p-2">
          <i class="mdi mdi-fingerprint mr-1"></i> Account Security
        </h4>

        <form @submit.prevent="updatePassword">
          <div class="form-group row">
            <label for="username" class="col-4 col-form-label"
              >Username
              <span class="text-danger">*</span>
            </label>
            <div class="col-8"
              ><input
                id="username"
                v-model="form.username"
                type="email"
                class="form-control"
            /></div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label"
              >Current Password
              <span class="text-danger">*</span>
            </label>
            <div class="col-8"
              ><input
                v-model="form.currentPassword"
                type="password"
                class="form-control"
                :class="{
                  'is-invalid': formsubmit && $v.form.currentPassword.$error,
                }"
              />
              <div
                v-if="formsubmit && $v.form.currentPassword.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.currentPassword.required"
                  >This value is required.</span
                >
                <span v-if="!$v.form.currentPassword.minLength"
                  >Password should be at least 8 characters.</span
                >
                <span v-if="!$v.form.currentPassword.maxLength"
                  >Password should be no more than 16 characters.</span
                >
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label"
              >New Password
              <span class="text-danger">*</span>
            </label>
            <div class="col-8"
              ><input
                v-model="form.newPassword"
                type="password"
                class="form-control"
                :class="{
                  'is-invalid': formsubmit && $v.form.newPassword.$error,
                }"
              />
              <div
                v-if="formsubmit && $v.form.newPassword.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.newPassword.required"
                  >This value is required.</span
                >
                <span v-if="!$v.form.newPassword.minLength"
                  >Password should be at least 8 characters.</span
                >
                <span v-if="!$v.form.newPassword.maxLength"
                  >Password should be no more than 16 characters.</span
                >
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-4 col-form-label"
              >Confirm Password
              <span class="text-danger">*</span>
            </label>
            <div class="col-8"
              ><input
                v-model="form.confirmPassword"
                type="password"
                class="form-control"
                :class="{
                  'is-invalid': formsubmit && $v.form.confirmPassword.$error,
                }"
              />
              <div
                v-if="formsubmit && $v.form.confirmPassword.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.confirmPassword.required"
                  >This value is required.</span
                >
                <span v-else-if="!$v.form.confirmPassword.sameAsPassword"
                  >Confirm Password should be the same with New Password.</span
                >
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-8 offset-4">
              <button type="submit" class="btn btn-danger"
                >Update Password</button
              >
              <button type="reset" class="btn btn-secondary m-l-5 ml-1"
                >Cancel</button
              >
            </div>
          </div>
        </form>

        <!-- <div class="col-12">
          <b-btn variant="danger" @click="updatePassword"
            >Change Password</b-btn
          >
        </div> -->
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { reqPasswordUpdate } from '@services'

import {
  required,
  //   email,
  minLength,
  sameAs,
  maxLength,
  //   minValue,
  //   maxValue,
  //   numeric,
  //   url,
  //   alphaNum,
} from 'vuelidate/lib/validators'

export default {
  page: {
    title: 'Account Security',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      form: {
        username: '',
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },

      //   submit: false,
      //   submitted: false,
      formsubmit: false,
      //   typesubmit: false,

      title: 'Account Security',
      items: [
        {
          text: 'Home',
          href: '/home',
        },
        {
          text: 'Account Security',
          active: true,
        },
      ],
    }
  },

  validations: {
    form: {
      currentPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
      },
      newPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(16),
      },
      confirmPassword: { required, sameAsPassword: sameAs('newPassword') },
    },
  },

  mounted() {
    this.form.username = this.$store.state.auth.current_account_setup.user_email
  },

  methods: {
    async updatePassword(e) {
      this.formsubmit = true

      // stop here if form is invalid

      this.$v.$touch()
      if (!this.$v.$invalid) {
        const updateResult = await reqPasswordUpdate({
          username: this.form.username,
          useruuid: this.$store.state.auth.current_account_setup
            .portal_user_uuid,
          oldpassword: this.form.currentPassword,
          newpassword: this.form.newPassword,
        })

        // console.log('updateResult = ', updateResult)
        this.$swal(updateResult.status, updateResult.message, updateResult.status.toLowerCase())
      }
    },
  },
}
</script>
